import * as types from './RADListActionType';
 
// Fetch Provider List
export const fetchRadListRequest = (filters = {}) => ({
    type: types.FETCH_RADLIST_REQUEST,
    payload: filters
});
export const fetchRadListSuccess = (data) => ({
    type: types.FETCH_RADLIST_SUCCESS,
    payload: data
});
export const fetchRadListFailure = (error) => ({
    type: types.FETCH_RADLIST_FAILURE,
    payload: error
});

// Dropdown Filter
export const dropdownFilterRequest = (filterParams = {}) => ({
    type: types.DROPDOWN_FILTER_REQUEST,
    payload: filterParams
});
export const dropdownFilterSuccess = (data) => ({
    type: types.DROPDOWN_FILTER_SUCCESS,
    payload: data
});
export const dropdownFilterFailure = (error) => ({
    type: types.DROPDOWN_FILTER_FAILURE,
    payload: error
});